import { isAfter, isBefore, isEqual, startOfDay, subDays } from 'date-fns';

export type ExceptionStat = {
    count: number;
    title: string;
    color?: string;
};

export function buildExceptionAgeDashboardStats(
    exceptionDates: Date[],
    referenceDate: Date
): ExceptionStat[] {
    const todayStart = startOfDay(referenceDate);
    const threeDaysAgo = subDays(todayStart, 3);
    const sevenDaysAgo = subDays(todayStart, 7);

    const exceptionsWithinThreeDays = exceptionDates.filter(createdDate =>
        isAfter(createdDate, threeDaysAgo)
    );
    const exceptionsBetweenThreeAndSevenDays = exceptionDates.filter(
        createdDate =>
            (isAfter(createdDate, sevenDaysAgo) ||
                isEqual(createdDate, sevenDaysAgo)) &&
            (isBefore(createdDate, threeDaysAgo) ||
                isEqual(createdDate, threeDaysAgo))
    );
    const exceptionsGreaterThanSevenDays = exceptionDates.filter(createdDate =>
        isBefore(createdDate, sevenDaysAgo)
    );

    return [
        {
            title: 'Age < 3 Days',
            color: 'var(--ant-success-color)',
            count: exceptionsWithinThreeDays.length,
        },
        {
            title: 'Age 3-7 Days',
            color: 'var(--ant-warning-color)',
            count: exceptionsBetweenThreeAndSevenDays.length,
        },
        {
            title: 'Age > 7 Days',
            color: 'var(--ant-error-color)',
            count: exceptionsGreaterThanSevenDays.length,
        },
    ];
}
